import { render } from "./QuickRepliesView.vue?vue&type=template&id=bc4e37f2&scoped=true"
import script from "./QuickRepliesView.vue?vue&type=script&lang=js"
export * from "./QuickRepliesView.vue?vue&type=script&lang=js"

import "./QuickRepliesView.vue?vue&type=style&index=0&id=bc4e37f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4e37f2"]])

export default __exports__